import script from "./RingCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./RingCarousel.vue?vue&type=script&setup=true&lang=js"

import "./RingCarousel.vue?vue&type=style&index=0&id=47ceff4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ceff4b"]])

export default __exports__